export const postTypes = [
  {
    id: -1,
    name: '☀️ Morning update',
    placeholder: 'What are you starting your day with?',
    content: `
Format: morning check-in.

Start with a short morning greeting.
Then list 1–3 small updates or things you're starting/working on.

Keep it simple and factual.

This should read like a quick status update, not a crafted post.
`,
  },
  {
    id: -2,
    name: '📈 Progress',
    placeholder: 'What changed or improved?',
    content: `
Format: simple progress update.

Start with a short, neutral opener.
Then list 1–3 concrete things that were improved, fixed, or built.

Keep it factual and specific.

Do not summarize the whole day.
Do not sound like a release announcement.

This should read like a quick “here’s what changed” update.
`,
  },
  {
    id: -3,
    name: '🚢 Shipped',
    placeholder: 'What did you ship or deploy?',
    content: `
Format: shipping update.

Start with a short statement that something is now live or deployed.
Then briefly mention what changed or what users can now do.

Focus on one main thing only.

Keep it simple and factual.

This should read like a quick “it’s live” update, not a launch post.
`,
  },
  {
    id: -4,
    name: '🌆 Wrap up',
    placeholder: 'What got done today?',
    content: `
Format: end-of-day update.

Start with a short closing phrase (ending the day, signing off, calling it a day).
Then list 1–3 small things that were finished or moved forward.

Keep it simple and factual.

This should read like a quick “done for today” note, not a report.
`,
  },
  {
    id: -5,
    name: '📆 Weekly',
    placeholder: 'What changed this week?',
    content: `
Format: weekly summary.

Start with a short header (weekly update or similar).
Then list 3–6 concrete things that were shipped, fixed, or improved this week.

Keep it structured and factual.
Prioritize clarity over personality.

This should read like a simple work log, not a crafted post.
`,
  },
  {
    id: -6,
    name: '📋 Log',
    placeholder: 'What changed this week?',
    content: `
Format: short project update with a header and bullet list.

Start with one short intro line mentioning the project or update.
Then list 3–6 concrete code or product changes as bullet points.

Rules:
- Each bullet starts with a verb (Added / Fixed / Improved / Refactored)
- Be specific and technical
- No storytelling or reflections
- No hype or marketing language
- Keep it simple and factual

This should read like a human-written changelog, not a crafted post.
`,
  },
]
